import {HospitalsService} from '../../services/hospitals.service';
import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-hospitals',
  templateUrl: './hospitals.component.html',
  styleUrls: ['./hospitals.component.css']
})
export class HospitalsComponent implements OnInit {


  data =[]
  constructor(private hospital_service: HospitalsService) {
  }

  ngOnInit() {
    this.hospital_service.getAll()
      .subscribe(hospitals => {
          this.data = hospitals.results
        },
        error => {
          alert("Could not fetch all hospitals")
        });
  }

}



// WEBPACK FOOTER //
// ./src/app/components/hospitals/hospitals.component.ts